module.exports = __webpack_public_path__ + "img/news2.d46aa07c.jpg";